export const PIN_LENGTH = 6;

export const DISPLAY_DATE_FORMAT_WITH_TIME_CZE = 'd.M.y HH:mm';
export const DISPLAY_DATE_FORMAT_WITHOUT_TIME_CZE = 'dd.MM.y';
export const DISPLAY_DATE_FORMAT_WITH_TIME_BEL = 'dd/MM/y HH:mm';
export const DISPLAY_DATE_FORMAT_WITHOUT_TIME_BEL = 'dd/MM/y';
export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd HH:mm';
export const MAX_PHONE_NUMBER_LENGTH = 15;
